export enum ApiCallModalType {
  AUTO_SEARCH_ERROR,
  AUTO_SEARCH_FORBIDDEN,
  FINMON_ERROR,
  AUTO_SEARCH_SUCCESS,
  OTP,
  LOADING,

  // CUSTOM_LOADING,
  INFO,
  AGREEMENT,
  ERROR,
  // CUSTOM_ERROR,
}

export interface ApiCallsAutoSearchSuccessModalData {
  plateNumber?: string | null;
  icon?: string;
  country?: string;
  model?: string;
  brand?: string;
  submitStepId?: string;
  cancelStepId?: string;
}

export interface ApiCallsAutoSearchErrorModalData {
  stepId: string;
  plateNumber?: string;
}
export interface OTPModalData {
  identificationCodeId: string | null;
  controlCode: string | null;
  objects: any[];
  errors: {
    errorCode: string;
    errorDescription: string;
    errorType: string; // BusinessError
  }[];
}
export interface FinmonErrorModalData {
  cancelButtonLink?: string;
  submitButtonLink?: string;
  error?: Error
}
export interface CustomErrorModalData {
  title: string;
  description: string;
  onCancel: Action;
  onSubmit: Action;
}
export interface LoadingModalPayload {
  title: string;
  description: string;
  disableClose?: boolean;
  progress?: number;
}

export type ModalClickHandler = (navFunctions: {
  nextStep: () => void;
  prevStep: () => void;
  specificStep: (stepId: string) => void;
  handleApiCallByName: (actionName: string, withoutSideEffect: boolean, params?: {
    additionalParams?: { onSuccessData?: any; onErrorData?: any };
    formDataOverride?: any;
    paramsOverride?: any;
    mapper?: any;
  }) => Promise<void>;
}) => void | Promise<void>;

export interface AgreementModalData {
  cancelText?: string;
  confirmText?: string;
  description?: string;
  linkText?: string;
  withCross?:boolean;
  onConfirmClick?: ModalClickHandler;
  onCancelClick?: ModalClickHandler;
  onLinkClick?: () => void;
}

export interface InfoModalData {
  title?: string;
  description?: string;
  cancelText?: string;
  submitText?: string;
  withCross?:boolean;
  onCancel?: ModalClickHandler;
  onSubmit?: ModalClickHandler;
  buttonsLayout?: "vertical" | "horizontal";
}

export interface ErrorModalData {
  title?: string;
  description?: string;
  cancelText?: string;
  submitText?: string;
  buttonsLayout?: "vertical" | "horizontal";
  onCancel?: ModalClickHandler;
  onSubmit?: ModalClickHandler;
}

export type LoadingModalData = LoadingModalPayload | undefined;

export enum ActionMethod {
  open_link = "open_link",
  apicall_rating = "apicall_rating",
  open_modal = "open_modal",
  navigation_next = "navigation_next",
  navigation_prev = "navigation_prev",
  navigation_step = "navigation_step",
  apicall = "apicall",
  viber = "viber",
  letter = "letter",
  contacts = "contacts",
}

export interface Action {
  method: ActionMethod;
  params: any;
  withLoader: boolean;
  loader: { title: string; description: string };
  additionalParams?: {
    onError?: Action;
    onSuccess?: Action;
  };
}

export type ModalDataType =
  | {
      type: ApiCallModalType.AUTO_SEARCH_SUCCESS;
      data: ApiCallsAutoSearchSuccessModalData;
    }
  | {
      type: ApiCallModalType.AUTO_SEARCH_ERROR;
      data: ApiCallsAutoSearchErrorModalData;
    }
  | {
    type:  ApiCallModalType.AUTO_SEARCH_FORBIDDEN;
    data: Pick<ApiCallsAutoSearchErrorModalData, "plateNumber">;
    }
  | { type: ApiCallModalType.LOADING; data: LoadingModalData }
  | { type: ApiCallModalType.OTP; data: OTPModalData }
  | { type: ApiCallModalType.FINMON_ERROR; data: FinmonErrorModalData }
  // | { type: ApiCallModalType.CUSTOM_ERROR; data: CustomErrorModalData }
  | { type: ApiCallModalType.INFO; data: InfoModalData }
  | { type: ApiCallModalType.ERROR; data: ErrorModalData }
  | { type: ApiCallModalType.AGREEMENT; data: AgreementModalData }

export interface ApiCallsModalStore {
  modal: null | ModalDataType;
  open: (type: ApiCallModalType, data: ModalDataType["data"]) => void;
  close: () => void;
}
